import * as React from 'react';

import { Content, ContentCard, ContentSection } from '@rematter/ui-web';
import { useAtomValue, useSetAtom } from 'jotai';

import {
  $agentDetailForm,
  $updateAgentDetailForm,
} from '../../_state/agentDetail.state';
import { useTranslations } from '../../i18n/useTranslations';

import { ToolSelector } from './ToolSelector';

export const AgentTabTools = () => {
  const t = useTranslations();
  const formData = useAtomValue($agentDetailForm);
  const updateFormData = useSetAtom($updateAgentDetailForm);

  const handleToolsChange = React.useCallback(
    (ids: string[]) => updateFormData({ toolIds: ids }),
    [updateFormData],
  );

  return (
    <Content className="@AgentTabTools p-4">
      <ContentCard>
        <ContentSection title={t.aiManagement.agents.details.sections.tools}>
          <p className="mb-4 text-sm text-neutral/60">
            {t.aiManagement.agents.details.fields.tools.description}
          </p>
          <ToolSelector
            selectedToolIds={formData.toolIds}
            onChange={handleToolsChange}
          />
        </ContentSection>
      </ContentCard>
    </Content>
  );
};
